import { useState } from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
//import { FacebookCircleIcon, GoogleCircleIcon, LinkedInCircleIcon } from '../../icons'
import './styles.sass'
import { signupCreator } from '../../store/reducers/SignupReducer'
//import vkLogo from '../LoginForm/vk.svg'
interface SignupForm {
    email: {
        value: string,
        changed: boolean
    };
    password: {
        value: string,
        changed: boolean
    };
    confirmPassword: {
        value: string,
        changed: boolean
    };
}

interface SignupErrors {
    email: string;
    password: string;
    confirmPassword: string;
}

export const SignUpForm = () => {
    // function getVk(){
    //     document.location.href = `${process.env.REACT_APP_API_VK}/authorization/vk`
    
    // }
    const intl = useIntl()
    const dispatch = useDispatch()

    const isUserExistError= useSelector( (state: any) => (state.signup.userExistError))

    const [isValid, setIsValid] = useState<boolean>(false)
    const [form, setForm] = useState<SignupForm>({
        email: {
            value: '',
            changed: false
        },
        password: {
            value: '',
            changed: false
        },
        confirmPassword: {
            value: '',
            changed: false
        }
    })
    const [errors, setErrors] = useState<SignupErrors>({
        email: '',
        password: '',
        confirmPassword: ''
    })

    const [checkboxes, setCheckboxes] = useState({
        personalData: false,
        confidentialityPolicy: false
    });
    const handleCheckboxChange = (name: keyof typeof checkboxes) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckboxes(prev => ({
            ...prev,
            [name]: event.target.checked
        }));
    };

    const validate = () => {
        let isValidTemp = true;
        let errorsTemp = {
            email: '',
            password: '',
            confirmPassword: ''
        };

        if (!form.email.value || !form.password.value || !form.confirmPassword.value) {
            isValidTemp = false;
        }

        if (form.email.changed && !form.email.value) {
            isValidTemp = false;
            errorsTemp.email = 'signup_text_error_must_field';
        }

        if (form.email.changed && typeof form.email.value !== "undefined") {
            let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})]?$)/i);
            if (!pattern.test(form.email.value)) {
                isValidTemp = false;
                errorsTemp.email = "signup_text_error_incorrect_email";
            }
        }

        if (form.password.changed && !form.password.value) {
            isValidTemp = false;
            errorsTemp.password = 'signup_text_error_must_field';
        }

        if (form.password.changed && typeof form.password.value !== "undefined") {
            let passwordPattern = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()+=._-]{6,}$/)
            if (!passwordPattern.test(form.password.value) ) {
                isValidTemp = false;
                errorsTemp.password = "signup_text_error_password_length";
            }

        }

        if (form.confirmPassword.changed && !form.confirmPassword.value) {
            isValidTemp = false;
            errorsTemp.confirmPassword = 'signup_text_error_must_field';
        }

        if (form.confirmPassword.changed || form.password.changed) {
            if (form.confirmPassword.value !== form.password.value) {
                isValidTemp = false;
                errorsTemp.confirmPassword = "signup_text_error_passwords_not_match";
            }
        }

        setErrors(errorsTemp);
        setIsValid(isValidTemp);
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (isValid && checkboxes.confidentialityPolicy && checkboxes.personalData) {
            dispatch(signupCreator({
                login: form.email.value,
                password: form.password.value
            }))
        } else {
            validate()
        }
    }

    const handleChange = (event) => {

        switch (event.target.name) {
            case "email":
                setForm(
                    {
                        ...form,
                        email: {
                            value: event.target.value,
                            changed: true
                        }
                    }
                );
                break;
            case "password":
                setForm(
                    {
                        ...form,
                        password: {
                            value: event.target.value,
                            changed: true
                        }
                    }
                );
                break;
            case "confirmPassword":
                setForm(
                    {
                        ...form,
                        confirmPassword: {
                            value: event.target.value,
                            changed: true
                        }
                    }
                );
                break;
        }

        validate()
    }

    return (
        <form className='sign-up-form-wrapper' onSubmit={handleSubmit}>
            <span className='sign-up-title'>
                <FormattedMessage id='sign_up_form_title'/>
            </span>

            {
                isUserExistError
                &&
                <div className='login-error-panel'>
                    <span className='login-error-panel__title'>
                        <FormattedMessage id='signup_validation_error_title'/>
                    </span>

                    <span className='login-error-panel__sub-title'>
                        <FormattedMessage id='signup_validation_error_text'/>
                    </span>
                </div>
            }

            <div className={`text-input`}>
                <input
                    type='email'
                    placeholder={ intl.formatMessage({ id: 'sign_up_form_email_placeholder' }) }
                    value={form.email.value}
                    name={"email"}
                    onChange={handleChange}
                    onBlur={validate}
                    className={`${ !isValid && errors.email.length !== 0 && 'error-input'}`}
                />
                {
                    !isValid && errors.email.length !== 0
                    &&
                    <span className={"error-text"}><FormattedMessage id={errors.email}/></span>
                }
            </div>
            <div className={`text-input`}>
                <input
                    type='password'
                    placeholder={ intl.formatMessage({ id: 'sign_up_form_pass_placeholder' })}
                    value={form.password.value}
                    name={"password"}
                    onChange={handleChange}
                    onBlur={validate}
                    className={`${ !isValid && errors.password.length !== 0 && 'error-input'}`}
                />
                {
                    !isValid && errors.password.length !== 0
                    &&
                    <span className={"error-text"}><FormattedMessage id={errors.password}/></span>
                }
            </div>
            <div className={`text-input`}>
                <input
                    type='password'
                    placeholder={ intl.formatMessage({ id: 'sign_up_form_pass_confirm_placeholder' })}
                    value={form.confirmPassword.value}
                    name={"confirmPassword"}
                    onChange={handleChange}
                    onBlur={validate}
                    className={`${ !isValid && errors.confirmPassword.length !== 0 && 'error-input'}`}
                />
                {
                    !isValid && errors.confirmPassword.length !== 0
                    &&
                    <span className={"error-text"}><FormattedMessage id={errors.confirmPassword}/></span>
                }
            </div>
            <button
                type="submit"
                disabled={!isValid || !checkboxes.confidentialityPolicy || !checkboxes.personalData}
                className={`green-button ${ !isValid || !checkboxes.confidentialityPolicy || !checkboxes.personalData ? 'disabled-button' : '' }`}
            >
                <FormattedMessage id='signup_page_reg_button'/>
            </button>
            <div className="registration-politics">
                <input
                    type="checkbox"
                    checked={checkboxes.confidentialityPolicy}
                    onChange={handleCheckboxChange('confidentialityPolicy')}
                />
                <span>
                Вы соглашаетесь с <a target="_blank" href="https://sociomonitoring.ru/upload/legal/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5.pdf" style={{textDecoration: 'underline', color: '#219653'}}> политикой конфиденциальности</a>
                </span>
            </div>
            <div className="registration-politics">
                <input
                    type="checkbox"
                    checked={checkboxes.personalData}
                    onChange={handleCheckboxChange('personalData')}
                />
                <span>
                Вы даете согласие на <a target="_blank" href="https://sociomonitoring.ru/upload/legal/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0%20%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B8%20%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85%20%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85%20%D0%9E%D0%9E%D0%9E%20%D0%A1%D0%9C%D0%A1.pdf" style={{textDecoration: 'underline', color: '#219653'}}> обработку персональных данных</a>
                </span>
            </div>
           {/*  <div className='social-networks-login-wrapper'>
                <span>Или войти с помощью</span>
                <div>
                   
                    <span onClick={() => getVk()}>
                        <img src={vkLogo} style={{width: '50px', cursor: 'pointer'}}/>
                    </span>
                </div>
            </div> */}
           
        </form>
    )
}
